import React from 'react';

const GameControls = ({ gameState, onStart, onReset }) => {
  const getStartButtonText = () => {
    switch (gameState) {
      case 'playing':
        return 'GAME RUNNING...';
      case 'paused':
        return 'RESUME';
      default:
        return 'START GAME';
    }
  };

  const isStartDisabled = gameState === 'playing';

  return (
    <div className="game-controls">
      <button 
        className="btn btn-primary" 
        onClick={onStart}
        disabled={isStartDisabled}
      >
        {getStartButtonText()}
      </button>
      <button 
        className="btn btn-secondary" 
        onClick={onReset}
      >
        RESET
      </button>
    </div>
  );
};

export default GameControls;
